<template>
  <div class="login-container">
    <div class="login-form-wrap">
      <el-form :model="form" status-icon class="login-ruleForm">
        <el-form-item>
          <el-input placeholder="请输入后台账号" v-model="form.username" />
        </el-form-item>
        <el-form-item>
          <el-input placeholder="密码" type="password" v-model="form.password" @keyup.enter.native="login" />
        </el-form-item>
        <el-form-item class="remember-item">
          <el-checkbox class="custom-checkbox" v-model="form.rememberme" text-color="#4caf50"
            fill="#4caf50">记住密码</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button class="login-btn" type="primary" :loading="loginLoading" @click="login">{{ loginLoading ? "登录中..."
            : "登 录" }}</el-button>
        </el-form-item>
        <el-form-item>
          <div class="SignContainer-tip">
            <div>请登录分配的账号进行管理</div>
            <a href="#">《遗失密码请联系管理员!》</a>
          </div>
        </el-form-item>
      </el-form>
      <div class="project-name">－{{ project_name }}－</div>
    </div>

    <footer class="SignFlowHomepage-footer">
      <span>2019 © 深圳市佳视联科技有限公司 联系电话：400-889-3659</span>
    </footer>
  </div>
</template>

<script>
import config from "../../utils/config/config";
import authorize from "../../utils/base/authorize";
import axios from "axios";
import dynamicRouter from "../../router/dynamic-router";
export default {
  name: "Login",
  data() {
    return {
      loginLoading: false, // 是否处在登录中
      project_name: config.project_name,
      form: {
        username: "",
        password: "",
        rememberme: false
      }
    };
  },

  mounted: function () {
    let account = authorize.getAccount();
    if (account) {
      this.form.username = account.username;
      this.form.password = account.password;
      this.form.rememberme = true;
    }
  },
  methods: {
    login() {
      if (!this.form.username || !this.form.password) return this.$message.error("账号或密码不能为空");
      this.loginLoading = true;

      //保存／清除账号
      if (this.form.rememberme) {
        authorize.saveAccount(this.form.username, this.form.password);
      } else {
        authorize.clearAccount();
      }

      const post_data = {
        share_user: this.form.username,
        share_password: this.form.password
      };

      this.$network
        .post(this.$api.login, post_data)
        .then(res => {
          authorize.saveToken(res.token);
          this.$network.post(this.$api.get_user_info, "", true).then(userinfo => {
            this.$store.commit("SET_USER_INFO", userinfo);
            const dyRouters = dynamicRouter.generateRouteByPermision(
              dynamicRouter.routes,
              userinfo.permission
            );
            this.$router.addRoutes(dyRouters);

            const target =
              (this.$route.query && this.$route.query.redirect) ||
              (userinfo.menu &&
                userinfo.menu[0] &&
                userinfo.menu[0].children &&
                userinfo.menu[0].children[0] &&
                userinfo.menu[0].children[0].action) ||
              config.index_path;
            console.log("target", target, dyRouters);
            this.$router.replace(target).catch(() => { });
            this.loginLoading = false;
          });
          //跳转
        })
        .catch(err => {
          this.$toast({
            title: err,
            type: "error"
          });

          this.loginLoading = false;
        });
    }
  }
};
</script>


<style lang="less" scoped>
@import "../../less/variable";

.login-container {
  width: 100%;
  // height: 100vh;
  height: 100%;
  background-image: url(https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg);
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;

  // 添加动态粒子背景效果
  &::before {
    // content: "";
    // position: absolute;
    // top: 0;
    // left: 0;
    // width: 100%;
    // height: 100%;
    // // background: radial-gradient(circle, transparent 20%, rgba(255,255,255,0.1) 20%, rgba(255,255,255,0.1) 80%, transparent 80%, transparent);
    // background-size: 30px 30px;
    // opacity: 0.3;
    // animation: particleMove 60s linear infinite;
  }

  .login-form-wrap {
    width: 100%;
    max-width: 480px;
    padding: 0 20px;
    z-index: 2;
    animation: fadeInUp 0.6s ease-out;

    .login-ruleForm {
      background-color: rgba(255, 255, 255, 0.95);
      backdrop-filter: blur(12px);
      border-radius: 16px;
      padding: 40px;
      box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15),
        inset 0 1px 0 rgba(255, 255, 255, 0.2);
      transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

      &:hover {
        box-shadow: 0 14px 28px rgba(0, 0, 0, 0.2);
      }

      // 输入框样式
      /deep/ .el-input {
        margin-bottom: 24px;

        .el-input__inner {
          height: 48px;
          padding: 0 16px;
          font-size: 15px;
          border-radius: 10px;
          border: 1px solid #e0e0e0;
          background-color: rgba(255, 255, 255, 0.9);
          transition: all 0.3s ease;

          &:focus {
            border-color: #4caf50;
            box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.2);
          }

          &::placeholder {
            color: #b0b0b0;
            font-weight: 300;
          }
        }
      }

      // 记住密码样式
      /deep/ .remember-item {
        margin-bottom: 20px;

        .el-checkbox {
          &__label {
            color: #666;
            font-size: 14px;
          }

          &__inner {
            width: 16px;
            height: 16px;
            border: 1px solid #ddd;

            &:hover {
              border-color: #4caf50;
            }

            &::after {
              border-width: 2px;
              left: 5px;
              top: 1px;
            }
          }
        }
      }

      // 登录按钮样式
      .login-btn {
        width: 100%;
        height: 48px;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 1px;
        border-radius: 10px;
        background: linear-gradient(135deg, #4caf50, #2e7d32);
        border: none;
        box-shadow: 0 4px 6px rgba(76, 175, 80, 0.2);
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(76, 175, 80, 0.3);
          background: linear-gradient(135deg, #2e7d32, #4caf50);
        }

        &:active {
          transform: translateY(0);
        }
      }

      // 提示信息样式
      .SignContainer-tip {
        margin-top: 20px;
        padding: 12px 16px;
        background-color: #f5f9f5;
        border-radius: 8px;
        font-size: 13px;
        color: #666;

        a {
          color: #4caf50;
          font-weight: 500;
          transition: color 0.2s;

          &:hover {
            color: #2e7d32;
            text-decoration: underline;
          }
        }
      }
    }

    // 项目名称样式
    .project-name {
      width: 100%;
      text-align: center;
      margin-top: 30px;
      font-size: 24px;
      font-weight: 600;
      color: white;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
      letter-spacing: 1px;
    }
  }

  // 页脚样式
  .SignFlowHomepage-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 15px 0;
    background-color: rgba(0, 0, 0, 0.4);
    color: rgba(255, 255, 255, 0.8);
    font-size: 13px;
    text-align: center;
    backdrop-filter: blur(5px);
  }
}

// 动画定义
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes particleMove {
  0% {
    transform: translateY(0) translateX(0);
  }

  50% {
    transform: translateY(-100px) translateX(100px);
  }

  100% {
    transform: translateY(0) translateX(0);
  }
}

// 响应式调整
@media (max-width: 768px) {
  .login-container {
    .login-form-wrap {
      padding: 0 15px;

      .login-ruleForm {
        padding: 30px 20px;

        /deep/ .el-input .el-input__inner {
          height: 44px;
          font-size: 14px;
        }

        .login-btn {
          height: 44px;
          font-size: 15px;
        }
      }

      .project-name {
        font-size: 20px;
        margin-top: 20px;
      }
    }

    .SignFlowHomepage-footer {
      font-size: 12px;
      padding: 12px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/site/Login.vue